import { Chip } from "@heroui/react"

const StatusChip = ({ msg, color, className, onClose }) => {
  if (!msg) return <></>
  return <Chip 
    className={className || 'ml-4 mb-4 h-auto whitespace-normal p-2 max-w-full'}
    color={color}
    size='lg'
    radius='sm'
    onClose={onClose}>
      {msg}
  </Chip>
}

export default StatusChip
